import styled from "styled-components";

export const ContainerBackground = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap");
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Inter" sans-serif;
`;

export const ContainerModal = styled.form`
  width: 295px;
  height: 274px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #212529;
  box-shadow: 0px 3px 32px -8px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  left: 14px;
  top: 150px;

  header {
    width: 255px;
    height: 40px;
    padding: 8px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #343b41;
    border-radius: 3.19783px 3.19783px 0px 0px;
    font-family: "Inter" sans-serif;
  }

  header h1 {
    color: #f8f9fa;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
  }

  header p {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: #868e96;
    cursor: pointer;
  }
  select {
    width: 265px;
    height: 38px;
    background: #343b41;
    border: 0.973899px solid #343b41;
    box-sizing: border-box;
    border-radius: 3.19783px;
    margin: 10px 0px;
    color: #868e96;
    font-style: normal;
    font-weight: 400;
    font-size: 12.9853px;
    line-height: 21px;
  }
  button {
    width: 163.09px;
    height: 38.37px;
    background: #59323f;
    border: 1.2182px solid #59323f;
    box-sizing: border-box;
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 12.7913px;
    line-height: 21px;
    color: #ffffff;
    cursor: pointer;
  }
  p {
    font-style: normal;
    font-size: 12px;
    color: #f8f9fa;
    margin: 10px;
  }
`;

export const ModalInput = styled.input`
  width: 265px;
  height: 38px;
  background: #343b41;
  border: 0.9772px solid #f8f9fa;
  box-sizing: border-box;
  border-radius: 3.20867px;
`;
